import { withInstall } from "../../utils";
import ImageVerification from "./src/image-verification.vue";

export const IImageVerification = withInstall(ImageVerification); // 增加类型

export default IImageVerification;
